module.exports = __webpack_public_path__ + "media/games-5.4bea2aab.mp4";